import { FormattedMessage } from 'react-intl';
import { Button } from '@ets/design-system';

import { navigateToPrevious } from 'router/navigation';
import { useSelector } from '_common/hooks';
import { selectActiveMenu } from '_common/components/Sidebar/SidebarSlice';

import styles from './Header.module.scss';

const Header = () => {
  const activeMenu = useSelector(selectActiveMenu);

  if (!activeMenu) {
    return null;
  }

  const goToPreviousLocation = () => {
    navigateToPrevious();
  };

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <FormattedMessage id={activeMenu.title.id} values={activeMenu.title.values} />
      </div>
      <Button
        variant="link"
        size="m"
        icon={{ name: 'xmark', color: 'light' }}
        onClick={goToPreviousLocation}
        style={{ margin: '0 0 0 1rem' }}
        testId="sidebar-menu-close"
      />
    </div>
  );
};

export default Header;
